import { Trans } from "@lingui/macro";
import type React from "react";
import type { FunctionComponent } from "react";

export const IconCommentOutline: FunctionComponent<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>
        <Trans>Comment icon</Trans>
      </title>
      <path
        d="M1.02814 10.0033H1.02815V9.99951C1.02815 7.61211 1.97522 5.32277 3.66056 3.63505C4.49505 2.79939 5.48565 2.13658 6.57577 1.68441C7.66589 1.23223 8.83422 0.999512 10.0141 0.999512C12.3968 0.999512 14.6823 1.94738 16.3676 3.63505C18.0529 5.32277 19 7.61211 19 9.99951C19 12.3869 18.0529 14.6763 16.3676 16.364C14.6823 18.0516 12.3968 18.9995 10.0141 18.9995H1.03194L2.99257 17.0361L3.63366 16.3941L3.05689 15.6938C1.73812 14.0925 1.02029 12.0793 1.02814 10.0033Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};
